import { useContext } from 'react';
import AppContext from '../../../store/appContext';

const Status = () => {
  const { oper } = useContext(AppContext);

  return <div>{oper && <h4 className="px-3 mb-3 text-center">Operator: {oper}</h4>}</div>;
};

export default Status;
